export * from './overlay.component';

export const OverlayTemplate = require("./overlay.component.html");
